import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CouponFormLayer from "../components/CouponFormLayer";

const CouponFormPage = () => {
    return (
        <MasterLayout>
            <CouponFormLayer />
        </MasterLayout>
    );
};

export default CouponFormPage;
